export const certifications = [
  {
    name: 'I-CAR Gold Class',
    detail: "The collision repair industry's highest training recognition for a shop.",
    comingSoon: false,
  },
  {
    name: 'Axalta Certified',
    detail: 'Trained and certified on Axalta paint systems and color matching.',
    comingSoon: false,
  },
  {
    name: 'OEM certifications',
    detail: 'Manufacturer certifications are on the way with our move to a new location.',
    comingSoon: true,
  },
];
